import { useEffect, useState } from "react";
import { Onfido } from "onfido-sdk-ui";
import { useAuth } from "@/hooks/use-auth";

export const OnfidoView = ({
  data,
  setIsLoading,
  isResumeOnfidoFlow,
  createMessage,
  addMessage,
  handleClose,
}: any) => {
  console.log(data, "data");
  const { user } = useAuth();
  const [completeData, setCompleteData] = useState(null);

  const onfidoTheme = {
    name: "light",
    config: {
      colorContentBody: "rgb(76,115,117)",
      colorContentTitle: "rgb(76,115,117)",
      colorContentSubtitle: "rgb(76,115,117)",

      colorContentButtonPrimaryText: "rgb(255,255,255)",
      colorBorderButtonPrimary: "rgb(76, 115, 117)",
      colorBackgroundButtonPrimary: "rgb(76, 115, 117)",
      colorBackgroundButtonPrimaryHover: "rgb(36, 61, 61)",
      colorBackgroundButtonPrimaryActive: "rgb(15, 118, 110)",

      colorContentButtonSecondaryText: "rgb(60,87,92)",
      colorBorderButtonSecondary: "rgb(244, 249, 248)",
      colorBackgroundButtonSecondary: "rgb(244, 249, 248)",
      colorBackgroundButtonSecondaryHover: "rgb(243, 255, 253)",
      colorBackgroundButtonSecondaryActive: "rgb(227, 255, 249)",
    },
  };

  // Helper function to wait/sleep
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    setIsLoading(false);
    console.log(data, "data");
    console.log(user, "user");
    console.log(isResumeOnfidoFlow, "isResumeOnfidoFlow");

    Onfido.init({
      token: isResumeOnfidoFlow
        ? user.sdkToken
          ? user.sdkToken
          : data.workflowRun.sdk_token
        : data.workflowRun.sdk_token,
      containerId: "onfido-mount",
      workflowRunId: isResumeOnfidoFlow
        ? user.workFlowRunId
          ? user.workFlowRunId
          : data.workflowRun.id
        : data.workflowRun.id,
      theme: onfidoTheme,
      onComplete: async function (completedData) {
        console.log(completedData, "completedData");
        setCompleteData(completedData);
        try {
          //Closing modal after verification completion
          await sleep(5000);
          handleClose();
        } catch (error) {
          console.error("Error sending completion data:", error);
        }
      },
      onError: function (error) {
        const tipMessage = createMessage(
          "Sorry! There is an issue while creating session, Please Try Again",
          false,
          { actionType: "complete", options: ["Try Now"] },
        );
        addMessage(tipMessage);
        console.error("Onfido error:", error);
        sleep(5000);
        handleClose();
      },
    });
  }, [data, setIsLoading]);

  return <div id="onfido-mount" style={{ height: "82vh", overflow: "auto" }} />;
};
